import "./AddPenaltiesOrDiscountTable.css";

import { Button, CircularProgress, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { AddPenaltiesOrDiscountTableHeader } from "./AddPenaltiesOrDiscountTableHeader";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import ClearIcon from "@mui/icons-material/Clear";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from 'primereact/inputtext';

let AddPenaltiesOrDiscountDDLData = [
  { label: "--", value: null },
  {
    label: "Add to Invoice Amount",
    value: true,
  },
  {
    label: "Deduct From Invoice Amount",
    value: false,
  },
];


let AddPenaltiesOrDiscountTaxableData = [
  // { label: "--", value: "Non Taxable" },
  {
    label: "Taxable",
    value: true,
  },
  {
    label: "Non Taxable",
    value: false,
  },
];

let columns = [
  { field: "label", headerName: "Label" },
  { field: "amount", headerName: "Amount" },
  { field: "type", headerName: "" },
  { field: "taxable", headerName: "" },
];

let emptyAddPenaltiesOrDiscountTableData = {
  id: null,
  label: null,
  amount: null,
  type: null,
  taxable: false,
}

interface IAddPenaltiesOrDiscountTable {
  addPenaltiesOrDiscountTableUpdatedData: (data: any) => void;
  addPenaltiesOrDiscountFieldsDataItems: any;
}
export const AddPenaltiesOrDiscountTable: FC<
  IAddPenaltiesOrDiscountTable
> = ({ addPenaltiesOrDiscountTableUpdatedData, addPenaltiesOrDiscountFieldsDataItems }) => {


  const [addPenaltiesOrDiscountFieldsTable, setAddPenaltiesOrDiscountFieldsTable] = useState<any>(
    addPenaltiesOrDiscountFieldsDataItems
  );

  const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  const [addPenaltiesFeildsEmpty, setAddPenaltiesFeildsEmpty] = useState(emptyAddPenaltiesOrDiscountTableData);

  useEffect(() => {
    addPenaltiesOrDiscountTableUpdatedData(addPenaltiesOrDiscountFieldsTable);
  }, [addPenaltiesOrDiscountFieldsTable]);

  useEffect(() => {
    setAddPenaltiesOrDiscountFieldsTable(addPenaltiesOrDiscountFieldsDataItems);
  }, [addPenaltiesOrDiscountFieldsDataItems]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < addPenaltiesOrDiscountFieldsTable.length; i++) {
      if (addPenaltiesOrDiscountFieldsTable[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  const openNew = () => {
    console.log('openNew called');
    console.log('Current table length:', addPenaltiesOrDiscountFieldsTable.length);

    // if (addPenaltiesOrDiscountFieldsTable && addPenaltiesOrDiscountFieldsTable.length >= 4) return null;

    let _addPenaltiesOrDiscountSetupPanelData = [...addPenaltiesOrDiscountFieldsTable];
    let _addPenaltiesOrDiscountSetupPanelNewRow: any = { ...addPenaltiesFeildsEmpty };

    if (addPenaltiesFeildsEmpty.id) {
      const rowIndex = findIndexById(addPenaltiesFeildsEmpty.id);
      _addPenaltiesOrDiscountSetupPanelData[rowIndex] = _addPenaltiesOrDiscountSetupPanelNewRow;
      console.log('Updating existing row at rowIndex:', rowIndex);
    } else {
      const newRowId = createId();
      _addPenaltiesOrDiscountSetupPanelNewRow.id = newRowId;
      _addPenaltiesOrDiscountSetupPanelData.push(_addPenaltiesOrDiscountSetupPanelNewRow);
      setLastAddedRowId(newRowId && newRowId);
      console.log('New row added with ID:', newRowId);
      console.log('New table length:', _addPenaltiesOrDiscountSetupPanelData.length);
      console.log('Icon will show ONLY on row with ID:', newRowId);
    }
    setAddPenaltiesOrDiscountFieldsTable(_addPenaltiesOrDiscountSetupPanelData);
    setAddPenaltiesFeildsEmpty(emptyAddPenaltiesOrDiscountTableData);
  };


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {

    setAddPenaltiesOrDiscountFieldsTable((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
      return updatedData;
    });
  };

  const onDeleteNewAddedRow = (rowId: any) => {
    setAddPenaltiesOrDiscountFieldsTable((prev: any[]) => {
      const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

      if (rowDeleteBasedOnId.length > 1) {
        const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
        setLastAddedRowId(lastRowId);
      } else {
        setLastAddedRowId(null);
      }
      return rowDeleteBasedOnId;
    });
  }

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "label") {
      return "p-component p-filled p-input-text";
    } else if (field.field === "amount") {
      return "p-component p-filled p-inputnumber-input";
    } else if (field.field === "type") {
      return "p-component p-filled input-dropdown-fields drop-down-field";
    } else if (field.field === "taxable") {
      return "p-component p-filled input-dropdown-fields drop-down-field-taxable";
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "label") {
      return (
        <InputText
          value={rowData[x.field]}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
          className={renderErrorClass(x, row.rowIndex, rowData)}
          // type="text"
          // className="w-full"
          style={{ borderRadius: "2px 0px 0px 2px" }}
        />
      );
    } else if (x.field === "amount") {
      return (
        <InputNumber
          value={rowData[x.field]}
          className={renderErrorClass(x, row.rowIndex, rowData)}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right", borderRadius: "2px" }}
        />
      );
    }
    else if (x.field === "type") {
      return (
        <Dropdown
          options={AddPenaltiesOrDiscountDDLData}
          value={rowData[x.field]}
          onChange={(e: any) =>
            onCellValueChange(x, row.rowIndex, e.target.value)
          }
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
          optionLabel="label"
          optionValue="value"
          style={{ borderRadius: "2px" }}
        />
      );
    }
    else if (x.field === "taxable") {
      return (
        <>
          <Dropdown
            options={AddPenaltiesOrDiscountTaxableData}
            value={rowData[x.field]}
            onChange={(e: any) =>
              onCellValueChange(x, row.rowIndex, e.target.value)
            }
            // placeholder="--"
            className={renderErrorClass(x, row.rowIndex, rowData)}
            optionLabel="label"
            optionValue="value"
            style={{ borderRadius: "2px", maxWidth: "150px!important" }}
          />
        </>
      );
    }
  };



  return (
    <>
      <div className="card">
        {/* <AddPenaltiesOrDiscountTableHeader
          openNew={openNew}
        /> */}
        <DataTable
          value={addPenaltiesOrDiscountFieldsTable}
          dataKey="id"
          key={lastAddedRowId}
          showGridlines
          className="AddPenaltiesOrDiscountTableCss"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="516px"
        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                columnKey={x.field}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}

          {/* <Column
            body={(rowData: any, row: any) => {
              const showIcon = rowData.id === lastAddedRowId;
              console.log(`Row ${row.rowIndex} (ID: ${rowData.id}): lastAddedRowId=${lastAddedRowId}, showIcon=${showIcon}`);
              return showIcon ? (
                <Button
                  data-testid={`delete`}
                  color="warning"
                  onClick={() => onDeleteNewAddedRow(rowData.id)}
                  sx={{ height: "35px", minWidth: "50px" }}
                >
                  <ClearIcon fontSize="large" sx={{ height: "22px" }} />
                </Button>
              ) : null;
            }}
          // style={{ padding: "0!important" }}
          /> */}


        </DataTable>
      </div>
    </>
  );
};
